import { useMemo, useState, useEffect } from 'react';
import { throttle } from 'lodash';

const THROTTLE_EVENTS_MS = 75;

const useInnerHeight = (): number => {
  const [initialViewportHeight, setInitialViewportHeight] = useState(window.innerHeight);
  const [ih, setIh] = useState<number>(initialViewportHeight);

  const handleResize = useMemo(
    () =>
      throttle(
        () => {
          setIh(window.innerHeight ?? 0);
        },
        THROTTLE_EVENTS_MS,
        { leading: false, trailing: true },
      ),
    [],
  );

  useEffect(() => {
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [handleResize]);

  return ih;
};

export default useInnerHeight;
